import React, { Component } from 'react';

export default class OlliLogo extends Component {
  render() {
    return (
      <div className="olli-logo-div">
        <img className="olli-logo" src="./img/accessible-olli-logo.svg" alt="#accessible_olli, forward-thinking transportation" />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/olli_logo.js